export type ProposalTemplate = 'tech' | 'creation' | 'consulting' | 'audit' | 'training';

export const PROPOSAL_TEMPLATES: ProposalTemplate[] = ['tech', 'creation', 'consulting', 'audit', 'training'];
export const PROPOSAL_TEMPLATE_LABELS: Record<ProposalTemplate, string> = {
  tech: 'Prestation',
  creation: 'Création',
  consulting: 'Conseil',
  audit: 'Audit',
  training: 'Formation',
};

export interface ProposalDeliverable {
  id: string;
  label: string;
  description?: string;
}

export interface ProposalExclusion {
  id: string;
  label: string;
}

export type PriceMode = 'tjm' | 'fixed';

export interface ProposalRecord {
  id: string;
  template: ProposalTemplate;
  number: string;
  mode?: 'client' | 'interne';
  projectId?: string;
  clientName: string;
  clientEmail?: string;
  missionName: string;
  context: string;
  contextDetails?: string;
  deliverables: ProposalDeliverable[];
  exclusions: ProposalExclusion[];
  internalRisks?: string;
  internalMargin?: number;
  internalWorkload?: number;
  internalHypotheses?: string;
  clarityScore?: number;
  profitabilityScore?: number;
  riskScore?: number;
  pricingMode: PriceMode;
  tjm: number;
  duration: number;
  durationUnit: 'jours' | 'mois';
  fixedPrice: number;
  fixedPriceDetail?: string;
  fixedDuration?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export const PROPOSAL_STORAGE_KEY = 'indxone.proposals.v1';

export function nextProposalNumber(existing: ProposalRecord[]) {
  const year = new Date().getFullYear();
  const numbers = existing
    .map((p) => p.number || '')
    .filter((num) => num.startsWith(`P-${year}-`));
  const max = numbers.reduce((highest, num) => Math.max(highest, parseInt(num.split('-')[2] || '0', 10)), 0);
  return `P-${year}-${String(max + 1).padStart(3, '0')}`;
}

export function createProposalDraft(overrides?: Partial<ProposalRecord>): ProposalRecord {
  const now = new Date().toISOString();
  return {
    id: `prop_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    template: 'tech',
    number: '',
    mode: 'client',
    projectId: undefined,
    clientName: '',
    missionName: '',
    context: '',
    deliverables: [],
    exclusions: [],
    internalRisks: '',
    internalMargin: 0,
    internalWorkload: 0,
    internalHypotheses: '',
    clarityScore: undefined,
    profitabilityScore: undefined,
    riskScore: undefined,
    pricingMode: 'tjm',
    tjm: 0,
    duration: 1,
    durationUnit: 'mois',
    fixedPrice: 0,
    createdAt: now,
    updatedAt: now,
    ...overrides,
  };
}
